(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-complete-the-look"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initOne(root){
    if (!root || root.dataset.ctlInitialized === 'true') return;
    root.dataset.ctlInitialized = 'true';

    var flkty = null;

    function unmountFlickity(){
      var carousel = root.querySelector('[data-ctl-carousel]');
      if (carousel && carousel._flkty) {
        carousel._flkty.destroy();
        delete carousel._flkty;
      }
      flkty = null;
    }

    function shouldEnableFlickity(){
      var ctlCount = parseInt(root.dataset.ctlCount || '0', 10);
      var isDesktop = window.innerWidth >= 900;
      
      if (isDesktop) {
        return ctlCount >= 5;
      } else {
        return ctlCount >= 3;
      }
    }

    function updateNavVisibility(){
      var nav = root.querySelector('[data-ctl-nav]');
      if (!nav) return;
      
      var ctlCount = parseInt(root.dataset.ctlCount || '0', 10);
      var isDesktop = window.innerWidth >= 900;
      
      // Hide nav on desktop if count is 3 or 4, show otherwise
      if (isDesktop && ctlCount > 2 && ctlCount <= 4) {
        nav.setAttribute('data-ctl-nav-hidden', 'true');
      } else {
        nav.removeAttribute('data-ctl-nav-hidden');
      }
    }

    function mountFlickity(){
      var carousel = root.querySelector('[data-ctl-carousel]');
      if (!carousel) return;

      if (carousel.children.length < 2) return;

      if (!shouldEnableFlickity()) return;

      if (carousel._flkty) { flkty = carousel._flkty; return; }

      flkty = new Flickity(carousel, {
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        draggable: '>1',
        imagesLoaded: true
      });
      carousel._flkty = flkty;
      carousel.classList.remove('ctl__carousel--no-flickity');

      var prevBtn = root.querySelector('.ctl__nav-btn--prev');
      var nextBtn = root.querySelector('.ctl__nav-btn--next');
      if (prevBtn) prevBtn.addEventListener('click', function(){ flkty.previous(); });
      if (nextBtn) nextBtn.addEventListener('click', function(){ flkty.next(); });

      if (!Flickity.prototype._imagesLoaded) {
        Array.from(carousel.querySelectorAll('img')).forEach(function(img){
          img.addEventListener('load', function(){ flkty && flkty.resize(); }, { once:true });
        });
      }
    }
  
    function isVisible(el){
      var cs = window.getComputedStyle(el);
      return cs && cs.display !== 'none' && cs.visibility !== 'hidden' && +cs.opacity > 0;
    }

    function whenVisible(cb){
      if (isVisible(root)) { cb(); return; }
      var mo = new MutationObserver(function(){
        if (isVisible(root)) { mo.disconnect(); cb(); }
      });
      mo.observe(root, { attributes:true, attributeFilter:['class','style'] });
    }

    function whenFlickityReady(cb){
      if (window.Flickity) { cb(); return; }
      var tries = 0, max = 30, t = setInterval(function(){
        if (window.Flickity){ clearInterval(t); cb(); }
        else if (++tries >= max){ clearInterval(t); }
      }, 100);
      window.addEventListener('load', function(){ if (window.Flickity) cb(); }, { once:true });
    }

    function updateCarouselLayout(){
      var carousel = root.querySelector('[data-ctl-carousel]');
      if (!carousel) return;
      
      if (shouldEnableFlickity()) {
        carousel.classList.remove('ctl__carousel--no-flickity');
        if (!carousel._flkty && carousel.children.length >= 2) {
          whenFlickityReady(mountFlickity);
        }
      } else {
        unmountFlickity();
        carousel.classList.add('ctl__carousel--no-flickity');
      }
    }

    function handleResize(){
      updateCarouselLayout();
      updateNavVisibility();
    }

    whenVisible(function(){ 
      updateCarouselLayout();
      updateNavVisibility();
      whenFlickityReady(mountFlickity); 
    });

    var resizeTimeout;
    window.addEventListener('resize', function(){
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(handleResize, 150);
    });

    document.addEventListener('shopify:section:load', function(e){
      if (e.target && e.target.contains(root)) {
        delete root.dataset.ctlInitialized;
        unmountFlickity();
        whenVisible(function(){ 
          updateCarouselLayout();
          updateNavVisibility();
          whenFlickityReady(mountFlickity); 
        });
      }
    });
    document.addEventListener('shopify:section:unload', function(e){
      if (e.target && e.target.contains(root)) {
        unmountFlickity();
        delete root.dataset.ctlInitialized;
      }
    });
  }

  document.querySelectorAll('[data-ctl-root]').forEach(initOne);

  // Enhance product image carousels with active slide management
  function enhanceImageCarousels(scope) {
    var carousels = scope.querySelectorAll('.product-carousel__product-image-carousel');
    if (!carousels.length) return;

    carousels.forEach(function(carousel) {
      if (carousel._imageCarouselEnhanced) return;
      carousel._imageCarouselEnhanced = true;

      var track = carousel.querySelector('.product-carousel__image-track');
      if (!track) return;

      var allSlides = carousel.querySelectorAll('.product-carousel__image-slide');
      if (allSlides.length <= 1) return;

      // Wait for the global initProductCardImageCarousels to initialize first
      setTimeout(function() {
        // Override the showSlide behavior by intercepting transform changes
        var originalTransform = track.style.transform;
        var observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
              var currentTransform = track.style.transform;
              if (currentTransform && currentTransform !== originalTransform) {
                // Extract slide index from transform
                var match = currentTransform.match(/translate3d\((-?\d+)px/);
                if (match) {
                  var translateX = parseInt(match[1]);
                  var slideWidth = carousel.clientWidth;
                  var currentIndex = Math.round(Math.abs(translateX) / slideWidth);
                  
                  // Update active slide classes
                  allSlides.forEach(function(slide, idx) {
                    if (idx === currentIndex) {
                      slide.classList.add('product-carousel__image-slide--active');
                    } else {
                      slide.classList.remove('product-carousel__image-slide--active');
                    }
                  });
                }
                originalTransform = currentTransform;
              }
            }
          });
        });

        observer.observe(track, { attributes: true, attributeFilter: ['style'] });

        // Set initial active state
        allSlides.forEach(function(slide, idx) {
          if (idx === 1) {
            slide.classList.add('product-carousel__image-slide--active');
          } else {
            slide.classList.remove('product-carousel__image-slide--active');
          }
        });
      }, 100);
    });
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', function() {
    var sections = document.querySelectorAll('[data-ctl-root]');
    sections.forEach(function(section) {
      setTimeout(function() {
        enhanceImageCarousels(section);
      }, 200);
    });
  });

  // Re-initialize when section loads in theme editor
  document.addEventListener('shopify:section:load', function(e) {
    var section = e.target.querySelector('[data-ctl-root]');
    if (section) {
      setTimeout(function() {
        enhanceImageCarousels(section);
      }, 200);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-component"] && !Shopify.designMode) return;
  try {
    
(function(){

  // Initialize mobile carousels - just set active class on first slide
  // On mobile, clones are hidden, so track stays at position 0 and first real slide is visible
  function initMobileImageCarousels(root){
    if (window.innerWidth >= 900) return;
    
    var carousels = root.querySelectorAll('.prc-card__image-carousel');
    if (!carousels.length) return;
    
    carousels.forEach(function(carousel){
      if (carousel._mobileCarouselInitialized) return;
      carousel._mobileCarouselInitialized = true;
      
      // On mobile, clones are hidden, so first real slide is at index 1 in DOM
      // Set active class on first real slide to make image visible
      var allSlides = carousel.querySelectorAll('.prc-card__image-slide');
      allSlides.forEach(function(slide, idx) {
        if (idx === 1) {
          // First real slide (after hidden clone at index 0)
          slide.classList.add('prc-card__image-slide--active');
        } else {
          slide.classList.remove('prc-card__image-slide--active');
        }
      });
    });
  }

  function initImageCarousels(root){
  if (window.innerWidth < 900) {
    initMobileImageCarousels(root);
    return;
  }

  var carousels = root.querySelectorAll('.prc-card__image-carousel');
  if (!carousels.length) return;

  carousels.forEach(function(carousel){
    if (carousel._imageCarouselInitialized) return;
    carousel._imageCarouselInitialized = true;

    var track = carousel.querySelector('.prc-card__image-track');
    if (!track) return;

    var slides = carousel.querySelectorAll('.prc-card__image-slide:not(.prc-card__image-slide--clone)');
    if (slides.length <= 1) return;

    var allSlides = carousel.querySelectorAll('.prc-card__image-slide');
    var prevBtn = carousel.querySelector('.prc-card__image-nav-btn--prev');
    var nextBtn = carousel.querySelector('.prc-card__image-nav-btn--next');

    var currentSlide = 1;
    var realSlideCount = slides.length;
    var viewportWidth = carousel.clientWidth;

    function updateViewportWidth(){
      viewportWidth = carousel.clientWidth;
    }

    function showSlide(index, smooth){
      if (smooth === undefined) smooth = true;
      updateViewportWidth();
      track.style.transition = smooth ? 'transform 0.3s ease' : 'none';
      var px = -index * viewportWidth;
      track.style.transform = 'translate3d(' + px + 'px, 0, 0)';
      
      // Update active slide class to control image visibility
      allSlides.forEach(function(slide) {
        slide.classList.remove('prc-card__image-slide--active');
      });
      
      // Mark the current slide as active (handles both real slides and clones)
      var activeSlideIndex = index;
      if (allSlides[activeSlideIndex]) {
        allSlides[activeSlideIndex].classList.add('prc-card__image-slide--active');
      }
      
      currentSlide = index;
    }

    function nextSlide(){
      var nextIndex = currentSlide + 1;
      showSlide(nextIndex, true);
      if (nextIndex === realSlideCount + 1) {
        setTimeout(function(){ showSlide(1, false); }, 300);
      }
    }

    function prevSlide(){
      var prevIndex = currentSlide - 1;
      showSlide(prevIndex, true);
      if (prevIndex === 0) {
        setTimeout(function(){ showSlide(realSlideCount, false); }, 300);
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        prevSlide();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        nextSlide();
      });
    }

    window.addEventListener('resize', function(){
      if (window.innerWidth < 900) return;
      showSlide(currentSlide, false);
    });

    showSlide(1, false);
    
    // Ensure initial state is set correctly
    allSlides.forEach(function(slide, idx) {
      if (idx === 1) {
        slide.classList.add('prc-card__image-slide--active');
      } else {
        slide.classList.remove('prc-card__image-slide--active');
      }
    });
  });
}

function initOne(root){
  if (!root || root.dataset.prcInitialized === 'true') return;
  root.dataset.prcInitialized = 'true';

  var flkty = null;

  function mountFlickity(){
    var carousel = root.querySelector('[data-prc-carousel]');
    if (!carousel || carousel.children.length < 2) return;

    if (carousel._flkty) { flkty = carousel._flkty; root.classList.remove('prc--hidden'); return; }
    if (!window.Flickity) {
      root.classList.remove('prc--hidden');
      return;
    }

    flkty = new Flickity(carousel, {
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      draggable: '>1',
      imagesLoaded: true
    });
    carousel._flkty = flkty;

    var prevBtn = root.querySelector('.prc__nav-btn--prev');
    var nextBtn = root.querySelector('.prc__nav-btn--next');
    if (prevBtn) prevBtn.addEventListener('click', function(){ flkty.previous(); });
    if (nextBtn) nextBtn.addEventListener('click', function(){ flkty.next(); });

    root.classList.remove('prc--hidden');

    if (!Flickity.prototype._imagesLoaded) {
      Array.from(carousel.querySelectorAll('img')).forEach(function(img){
        img.addEventListener('load', function(){ flkty && flkty.resize(); }, { once:true });
      });
    }
  }

  function unmountFlickity(){
    var carousel = root.querySelector('[data-prc-carousel]');
    if (carousel && carousel._flkty) {
      carousel._flkty.destroy();
      delete carousel._flkty;
    }
    flkty = null;
  }

  function injectReturnedHTML(htmlText){
    var temp = document.createElement('div');
    temp.innerHTML = htmlText;
    var returnedInner = temp.querySelector('[data-prc-inner]');
    if (!returnedInner) return false;

    var mountPoint = root.querySelector('[data-prc-mount]');
    if (!mountPoint) return false;
    mountPoint.innerHTML = '';
    mountPoint.appendChild(returnedInner);
    return true;
  }

  function fetchRecommendations(){
    var url = root.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function(r){ return r.text(); })
      .then(function(html){
        var injected = injectReturnedHTML(html);
        if (!injected) return;
        root.classList.remove('prc--hidden');
        mountFlickity();
        initImageCarousels(root);
        initMobileImageCarousels(root);
      })
      .catch(function(err){ console.error('PRC fetch error:', err); });
  }

  fetchRecommendations();

  document.addEventListener('shopify:section:load', function(e){
    if (e.target && e.target.contains(root)) {
      delete root.dataset.prcInitialized;
      unmountFlickity();
      fetchRecommendations();
    }
  });

  document.addEventListener('shopify:section:unload', function(e){
    if (e.target && e.target.contains(root)) {
      unmountFlickity();
      delete root.dataset.prcInitialized;
    }
  });
}

document.querySelectorAll('[data-prc-root]').forEach(initOne);
})();

  } catch(e) { console.error(e); }
})();
})();
